export const TERMLY_WEBSITE_UUID = "edbdee8b-b69a-4253-91f6-5a21c1d9b7a3";

export const TERMLY_PRIVACY_POLICY_URL =
  "https://app.termly.io/policy-viewer/policy.html?policyUUID=12d6a49f-79b5-46c7-a0a4-630160c3533a";

export const TERMLY_COOKIE_POLICY_URL =
  "https://app.termly.io/policy-viewer/policy.html?policyUUID=02b98716-5281-4f0c-a96d-476d30bc88d2";

export const TERMLY_TERMS_OF_SERVICE_URL =
  "https://app.termly.io/policy-viewer/policy.html?policyUUID=63f69c5c-ea68-4048-93a1-aeb72388712a";
